import { Modal, Button } from "react-bootstrap";
import React, { Component } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

class OnScreenKeyBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutName: "default",
      input: "",
    };
  }

  onChange = (input) => {
    this.setState({ input });
    console.log("Input changed", input);
  };

  onKeyPress = (button) => {
    console.log("Button pressed", button);
    if (button === "{shift}" || button === "{lock}") this.handleShift();
  };

  handleShift = () => {
    const layoutName = this.state.layoutName;
    this.setState({
      layoutName: layoutName === "default" ? "shift" : "default",
    });
  };

  render() {
    const { keyboardShowHide, handleKeyboardShowHide } = this.props;
    return (
      <Modal show={keyboardShowHide} size="lg">
        <Modal.Header closeButton onClick={handleKeyboardShowHide}>
          <Modal.Title>Virtual Keyboard</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          <Keyboard
            keyboardRef={(r) => (this.keyboard = r)}
            layoutName={this.state.layoutName}
            onChange={this.onChange}
            onKeyPress={this.onKeyPress}
          />
        </Modal.Body>
        {/* <Modal.Footer className="justify-content-center">
          <Button variant="danger" onClick={handleKeyboardShowHide}>
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    );
  }
}

export default OnScreenKeyBoard;
